import { useSelector } from 'react-redux';
import { toggleValues } from 'platform/site-wide/feature-toggles/selectors';
import FEATURE_FLAG_NAMES from 'platform/utilities/feature-toggles/featureFlagNames';

export const VA_HOME_BREADCRUMB = { href: '/', label: 'VA.gov home' };
export const MY_VA_BREADCRUMB = { href: '/my-va/', label: 'My VA' };

// With the new My VA (bluesky) enabled, MHV breadcrumbs start at My VA so
// Veterans can get back to the dashboard they came from.
// Read by its snake_case name: vets-api camelizes VA as an acronym, so the
// camelCase entry is myVABlueskyEnabled, not myVaBlueskyEnabled.
export const selectMhvHomeBreadcrumb = state =>
  toggleValues(state)[FEATURE_FLAG_NAMES.myVaBlueskyEnabled]
    ? MY_VA_BREADCRUMB
    : VA_HOME_BREADCRUMB;

/**
 * Returns the first crumb for MHV breadcrumb trails. Render the trail with
 * `homeVeteransAffairs={false}`, otherwise va-breadcrumbs overwrites this
 * crumb's label with "VA.gov home".
 */
export const useMhvHomeBreadcrumb = () => useSelector(selectMhvHomeBreadcrumb);

/**
 * Replaces the first crumb of a trail with the given home crumb.
 */
export const withMhvHomeBreadcrumb = (crumbs, homeBreadcrumb) =>
  crumbs?.length ? [homeBreadcrumb, ...crumbs.slice(1)] : crumbs;
